import React from "react";

const RefundPolicy = () => {
  return (
    <div className="refund-container">
      <h1 className="refund-title">Refund Policy</h1>
      <p className="refund-description">
        At <strong>GoodPeople</strong>, we strive to provide the best possible experience for our users.  
        Since our services involve real-time communication and professional consultation,  
        **we do not offer refunds** except in very special circumstances.
      </p>

      <p className="refund-guidelines">
        If you believe you have encountered an issue that requires a refund, please reach out to our support team  
        at <strong>info@emomatrix.com</strong>, and we will carefully review your request.
      </p>

      <p className="refund-note">
        Our goal is to ensure fairness and customer satisfaction while maintaining the integrity of our platform.  
        We appreciate your understanding and support. 💙
      </p>
    </div>
  );
};

export default RefundPolicy;
